import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GetAccountInfoResponse, Vkc } from '@reflact/reflactportal';
import dayjs from 'dayjs';
import { saveAs } from 'file-saver';
import { firstValueFrom } from 'rxjs';
import { LoginService } from './login.service';

@Injectable({
  providedIn: 'root'
})
export class FaqService {
  public activeVkcs: Vkc[] = [];
  public serviceVkcs: Vkc[] = [];
  public serviceStatementVkcs: Vkc[] = [];

  constructor(private loginService: LoginService, private httpClient: HttpClient) {
  }

  public async getAccountInfo(): Promise<GetAccountInfoResponse> {
    const res = await firstValueFrom(this.httpClient.get<GetAccountInfoResponse>("/api/myreflact/accountinfo"));
    this.serviceStatementVkcs = res.accountInfo.vkcs.filter(vkc => (vkc.istrackable_c && vkc.istrackable_c == true) || dayjs().subtract(2, 'year').isBefore(vkc.date_closed));
    this.serviceVkcs = res.accountInfo.vkcs.filter(vkc => vkc.supportcontingent > 0 && dayjs().isBefore(vkc.supportenddate));
    this.activeVkcs = this.serviceVkcs.filter(vkc => !this.loginService.loggedInMandantUser?.excludeCrmIds.includes(vkc.crm_id));
    return res;
  }

  public downloadServiceStatement(crmId: string) {
    this.httpClient.get('/api/myreflact/serviceStatement/' + crmId, { responseType: 'text' }).subscribe(csv => {
      saveAs(new Blob([csv], { type: "text/csv;charset=utf-8" }), "products.csv");
    });
  }
}
